import React from 'react'
import './Product_Specification.css'
import { useParams } from "react-router-dom";
import All_products from '../../../common-components/all-products/All_products';

const Product_Specification = () => {

    const { id } = useParams();
    const product = All_products.find((p) => p.id === parseInt(id));

    const specification = [
        {
            title: "Material",
            subTitle: "Rudraksha Beads"
        },
        {
            title: "Product Specification",
            subTitle: "5 Mukhi Rudraksha"
        },
        {
            title: "Approx. Weight",
            subTitle: "Broccoli"
        },
        {
            title: "Rudraksha size",
            subTitle: "8 - 9 mm"
        },


    ]

    return (
        <div className='Product_Specification'>
            <h3>Specifications</h3>

            <div className='specification_div'>
                <ul>
                    {product.specs.map((spec, index) => (
                        <li key={index}>{spec}</li>
                    ))}
                </ul>
            </div>

        </div >
    )
}

export default Product_Specification
